import { useContext, useEffect } from "react";
import { Badge, Card, CardBody, Form, FormGroup } from "reactstrap";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ErrorMessage from "./../../../helpers/ErrorMessage/ErrorMessage";
import Button from "./../../../components/Button/Button";
import { Block } from "./../../../components/Block/Block";
import { editSettingValidation } from "../../../utils/validation/validation";
import { Col, Row } from "./../../../components/Grid/Grid";
import { settingAdminContext } from "../../../context/AdminContext/SettingAdminContext/SettingAdminContext";

const SettingAdmin = () => {
  const loader = useSelector((state) => state.loader);

  const { setting, handleGetSetting, handleEditSetting } =
    useContext(settingAdminContext);

  // Validation
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editSettingValidation),
  });

  useEffect(() => {
    handleGetSetting();
  }, []);

  useEffect(() => {
    if (!isEmpty(setting)) {
      setValue("charter724.orderTimeOut", setting?.charter724?.orderTimeOut);
    }
  }, [setting]);

  return (
    <>
      <SiteTitle title="تنظیمات" />

      <Card>
        <CardBody>
          <Block>
            <Form
              className="is-alter"
              onSubmit={handleSubmit(handleEditSetting)}
            >
              <Row className="gy-4">
                <Col size="12" sm="6" lg="4">
                  <FormGroup>
                    <label
                      className="form-label"
                      htmlFor="charter724.orderTimeOut"
                    >
                      زمان انتظار سفارشات چارتر 724{" "}
                      <Badge color="primary" className="badge-dim">
                        ثانیه
                      </Badge>
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="number"
                        placeholder="زمان انتظار سفارشات چارتر 724 را وارد نمایید"
                        className="form-control-lg form-control"
                        min={0}
                        id="charter724.orderTimeOut"
                        {...register("charter724.orderTimeOut")}
                      />
                      <ErrorMessage
                        message={errors.charter724?.orderTimeOut?.message}
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap">
                    <li>
                      <Button
                        color="primary"
                        size="lg"
                        type="submit"
                        loading={loader}
                      >
                        ویرایش تنظیمات
                      </Button>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Form>
          </Block>
        </CardBody>
      </Card>
    </>
  );
};

export default SettingAdmin;
